<template>
  <v-card color="#031b41">
    <div
      class="tw-bg-[#031b41] tw-flex tw-items-center tw-justify-between tw-px-5 tw-h-[55px] tw-py-2 tw-rounded-t-md tw-text-white tw-font-bold"
    >
      <div>Related Games</div>
    </div>
    <v-divider class="tw-border-[#2994ff] tw-border-[1px]"></v-divider>
    <div class="tw-space-y-3 tw-p-5">
      <div
        v-for="rgame in relatedGames"
        :key="rgame.id"
        class="hover:tw-bg-[#2994ff11] tw-rounded-xl tw-cursor-pointer"
        @click="initGame(rgame)"
      >
        <div class="tw-flex tw-space-x-3 tw-items-center tw-font-bold tw-select-none">
          <div>
            <v-img
              position="top center"
              class="tw-flex tw-items-end tw-rounded-md"
              :src="rgame.image"
              width="75px"
              height="75px"
              transition="scroll-y-reverse-transition"
            >
            </v-img>
          </div>
          <div class="tw-text-white tw-text-left">{{ rgame.name }}</div>
        </div>
      </div>
    </div>
  </v-card>
</template>

<script>
import { mapActions } from "vuex";
import { gameApi } from "../../api";
export default {
  props: ["game"],
  data() {
    return {
      relatedGames: [],
    };
  },

  watch: {
    game() {
      this.fetchRelatedGames();
    },
  },
  methods: {
    ...mapActions("game", ["getGameImage"]),
    async fetchRelatedGames() {
      try {
        const response = await gameApi.post(`/games/${this.game?.id}/related`);
        if (response.data.success) {
          this.relatedGames = response.data.data;
        }
      } catch (e) {
        console.log(e);
      }
    },
    async initGame(game) {
      const type = game.game_type != "slots" ? "real-live" : "real-slots";
      if (type.includes("live")) {
        this.$router.push({
          name: "Play",
          params: { type, id: game.id },
        });
      } else {
        this.$router.push({
          name: "Play",
          params: { type, id: game.id },
        });
      }
    },
    async getImage(game) {
      if (game.main_provider == "Slotegator") {
        const response = await this.getGameImage(game.image);
        return "data:image/bmp;base64," + response.image;
      } else {
        return this.game.image;
      }
    },
  },
};
</script>
